export default {
    power: {
        url: 'collections/power',
        include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa', 'eu'],
    },
    solar: {
        url: 'collections/solar',
        include: ['ca', 'za', 'jp', 'cn', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa', 'eu'],
    },
    smart: {
        url: 'collections/smart',
        include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa', 'eu'],
    },
};
